import { USER_REDUCER_ACTIONS } from "./enums";
export const getUserReducerAction = (storageSuffix, persistedReducer) => {
  if (persistedReducer && !storageSuffix) {
    return USER_REDUCER_ACTIONS.CLEAN;
  } else if (!persistedReducer && storageSuffix) {
    return USER_REDUCER_ACTIONS.INITIALIZE;
  } else if (persistedReducer) {
    return USER_REDUCER_ACTIONS.RETURN_PERSISTED;
  } else {
    return USER_REDUCER_ACTIONS.RETURN_DEFAULT;
  }
};